export default __webpack_public_path__ + "static/media/Support.9cefca10.png";